// import axios from 'axios'
// import { MessageBox, Message, Notification } from 'element-ui'
// import { getToken,setToken,removeToken } from '@/utils/auth'
// import router from '@/router'

// // create an axios instance
// const service = axios.create({
//   baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
//   // withCredentials: true, // send cookies when cross-domain requests
//   timeout: 1000 * 30 // request timeout
// })

// // request interceptor
// service.interceptors.request.use(
//   config => {
//     // 全局请求头
//     if(getToken()){
//       // console.info('token='+getToken());
//       config.headers['Authorization'] = 'bearer' + getToken();
//     }
//     return config
//   },
//   error => {
//     // do something with request error
//     console.log(error); // for debug
//     return Promise.reject(error)
//   }
// )

// // response interceptor
// service.interceptors.response.use(
//   /**
//    * If you want to get http information such as headers or status
//    * Please return  response => response
//   */

//   /**
//    * Determine the request status by custom code
//    * Here is just an example
//    * You can also judge the status by HTTP Status Code
//    */
//   response => {
//     const res = response.data;
//     if(res.refreshTokenFlag && res.refreshToken){
//       setToken(res.refreshToken);
//     }
//     if (res.code === 403) {
//       Notification({
//         title: '提示',
//         message: '请登录~',
//         type: 'warning'
//       });
//       removeToken();
//       // location.reload();
//       router.push({ path: '/login' })
//     } else if (res.code === 500) {
//       Message({
//         message: res.msg || '系统异常，请联系技术人员',
//         type: 'error',
//         duration: 2 * 1000
//       });
//       return res
//     } else if (res.code !== 200) {
//       console.info(res);
//       Message({
//         message: res.msg || '系统异常，请联系技术人员',
//         type: 'error',
//         duration: 2 * 1000
//       });
//       return Promise.reject(new Error(res.msg || 'Error'))
//     }
//     return res
//   },
//   error => {
//     console.log(error) // for debug
//     Message({
//       message: error.message,
//       type: 'error',
//       duration: 3 * 1000
//     })
//     return Promise.reject(error)
//   }
// )

// export default service
import axios from "axios";
import qs from "qs";
import router from "@/router";
import store from "@/store";
import { Message, Loading } from "element-ui";
// import { delCookie, deleteSessionStorage } from "@/utils/base.js";

//axios.defaults.timeout = 5000;                        //响应时间
axios.defaults.headers["Content-Type"] =
  "application/x-www-form-urlencoded;charset=UTF-8"; //配置请求头
// axios.defaults.baseURL = '';   //配置接口地址
// axios.defaults.baseURL = "/api/front/"; //配置接口地址
console.log(process.env.NODE_ENV);
// axios.defaults.baseURL = process.env.NODE_ENV === 'development' ? '/api/front/' : 'https://dywtest.zhcte.com/api/front/'
if (process.env.NODE_ENV !== 'production') {
  axios.defaults.baseURL = '/api/front/'
}else {
  axios.defaults.baseURL = 'https://dyw.chinaptac.com/api/front/'
}
axios.defaults.withCredentials = true;
axios.defaults.responseType = "json";
axios.defaults.timeout = 1000000;

//POST传参序列化(添加请求拦截器)
axios.interceptors.request.use(
  config => {
    // config.headers['token'] = localStorage.getItem('token');
    if (config.url=='/file/upload/image'||config.url=='/file/upload/auth/image') {
      config.headers["appId"] = 10001;
      return config
    }
    if (config.method === 'post' && !config.headers.uploadImg && !config.headers.postBody) {
      config.data = qs.stringify(config.data);
    }
    return config;
  },
  error => {
    console.log("错误的传参");
    return Promise.reject(error);
  }
);
//返回状态判断(添加响应拦截器)
axios.interceptors.response.use(
  res => {
    //未成功处理
    if (res.data.code !== 1) {
      console.log('未登录状态')
      if (res.data.code === 0) {
        Message({
          showClose: true,
          message: res.data.msg,
          type: "error"
        });
        return Promise.reject(res.data);
      } else {
        router.push({
          path: "/login",
          query: {}
        });
        return Promise.reject(res.data);
      }
    }
    return res.data;
  },
  error => {
    Message({
      showClose: true,
      message: "接口请求异常，请稍后再试~",
      type: "error"
    });
    return Promise.reject(error);
  }
);

/**
 * 返回一个Promise(发送post请求)
 * errorback是否错误回调
 */
export function _post(url, params, errorback) {
  return new Promise((resolve, reject) => {
    let data = params;
    data = Object.assign({appId:10001,token:localStorage.getItem('token')||''},data)
    axios
      .post(url, data)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

/**
 * 返回一个Promise(发送get请求)
 * errorback是否错误回调
 */
export function _get(url, param, errorback) {
  return new Promise((resolve, reject) => {
    let data = param;
    data = Object.assign({appId:10001,token:localStorage.getItem('token')||''},data)
    axios
      .get(url, {
        params: data
      })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}
/**
 * 返回一个Promise(发送post请求)
 * errorback是否错误回调
 */
export function _postBody(url, params, errorback) {
  return new Promise((resolve, reject) => {
    let data = params;
    data = Object.assign({appId:10001},data)
    let headers = {
      "Content-Type": 'application/json;charset=UTF-8',
      'token': localStorage.getItem('token') || '',
      postBody: true
    }
    axios.post(url, data, { headers })
      .then(response => {
        resolve(response);
      })
      .catch((error) => {
        errorback && reject(error);
      })
  })
}

/**
 * 返回一个Promise(发送上传请求)
 * errorback是否错误回调
 */
export function _upload(url, formData, errorback) {
  return new Promise((resolve, reject) => {
    let headers = {
      "Content-Type": 'application/json;charset=UTF-8',
      postBody: true,
      appId:10001
    }
    axios
      .post(url, formData, headers)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export default {
  _post,
  _get,
  _upload,
  _postBody,
};



// WEBPACK FOOTER //
// ./src/utils/request.js